import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpBackend } from '@angular/common/http';
import { config } from '../../config/config';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
@Injectable()
export class SupportFormService {
  url: string;
  param = {};
  constructor(private http: HttpClient) {
   
  }
  supportreply(postdata){
    return this.http.post(config.url + '/api/support/reply',postdata)
  }
  supportData = {};
  supportFormData(){
    return this.supportData;
  }
  submitSupportForm(id,reply){
    return this.http.post(config.url + '/api/support/reply',{supportId:id,reply:reply})
    }
}


// WEBPACK FOOTER //
// ./src/app/layout/support-form/support-form-service.ts